import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import DeletePageContentModal from './DeletePageContentModal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function PageContentShowAll() {

  const [pageContentList, setPageContentList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [pageContentToDelete, setPageContentToDelete] = useState(null);

  const callApiPageContent = async () => {
    try {
      const headers = {
        'x-access-token': localStorage.getItem('jwttoken')
      };
      const url = process.env.REACT_APP_API_URL + 'pagecontent/showAll';
      const response = await axios.get(url, { headers });
      setPageContentList(response.data);
      setFilteredList(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    callApiPageContent();
  }, []);

  // Search filter
  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredList(pageContentList);
    } else {
      setFilteredList(
        pageContentList.filter(
          (item) =>
            (item.contentname || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (item.contenttitle || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (item.contentid || '').toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }
  }, [searchTerm, pageContentList]);

  const handleOpenDeleteModal = (pagecontent) => {
    setPageContentToDelete(pagecontent);
    setShowDeleteModal(true);
  };

  const handleDeletePage = async (pageContentToDeleteSrno) => {
    try {
      const headers = {
        'x-access-token': localStorage.getItem('jwttoken')
      };
      const url = process.env.REACT_APP_API_URL + `pagecontent/delete/${pageContentToDeleteSrno}`;
      await axios.delete(url, { headers });
      setShowDeleteModal(false);
      const updatedPageContentList = pageContentList.filter((item) => item.srno !== pageContentToDeleteSrno);
      setPageContentList(updatedPageContentList);
      toast.success("Page content deleted successfully", {
        position: "top-right",
        autoClose: 2000,
        theme: "colored",
      });
    } catch (error) {
      console.error(error);
      setShowDeleteModal(false);
      toast.error("Failed to delete page content", {
        position: "top-right",
        autoClose: 2000,
        theme: "colored",
      });
    }
  };

  return (
    <div>
      <ToastContainer />

      {/* Main Card Container */}
      <div className="main-card">

        {/* Toolbar Section */}
        <div className="toolbar-container">
          <h2 className="page-title">Page Content List</h2>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <span className="results-count">
              {filteredList.filter(item => item.isactive === 1).length} results
            </span>
            <input
              type="text"
              className="search-box"
              placeholder="Search by Name / Title / ID"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Link to="/createpagecontent" className="btn-add-primary">
              + Create New Page
            </Link>
          </div>
        </div>

        {/* Gradient Header */}
        <div className="table-header-panel">
          Page Content List
        </div>

        {/* Table */}
        <div style={{ overflowX: 'auto' }}>
          <table className="custom-table" style={{ tableLayout: 'auto', width: '100%', fontSize: '0.8rem' }}>
            <thead>
              <tr>
                <th style={{ padding: '10px 8px' }}>Sr No</th>
                <th style={{ padding: '10px 8px' }}>Page Content Id</th>
                <th style={{ padding: '10px 8px' }}>Page Content Name</th>
                <th style={{ padding: '10px 8px' }}>Page Content Tilte</th>
                <th style={{ padding: '10px 8px' }}>Page Content</th>
                <th style={{ padding: '10px 8px' }}>Page Content Type</th>
                <th style={{ padding: '10px 8px' }}>Page Id</th>
                <th style={{ padding: '10px 8px' }}>Page Location Id</th>
                <th style={{ padding: '10px 8px' }}>is Active</th>
                {/* <th>Created By</th>
                <th>Created On</th>
                <th>Updated By</th>
                <th>Updated On</th>   */}
                <th style={{ padding: '10px 8px' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="10">
                    <div className="loading-container">
                      <div className="spinner"></div>
                    </div>
                  </td>
                </tr>
              ) : filteredList.filter(item => item.isactive === 1).length === 0 ? (
                <tr>
                  <td colSpan="10">
                    <div className="empty-state">
                      <div className="empty-state-icon">📄</div>
                      <div className="empty-state-text">No page content found</div>
                    </div>
                  </td>
                </tr>
              ) : (
                filteredList
                  .filter(item => item.isactive === 1)
                  .map((item, index) => (
                    <tr key={index + item.exam_id}>
                      <td style={{ padding: '8px' }}>{item.srno}</td>
                      <td style={{ padding: '8px' }}>{item.contentid}</td>
                      <td style={{ padding: '8px', fontWeight: '600' }}>{item.contentname}</td>
                      <td style={{ padding: '8px' }}>{item.contenttitle}</td>
                      <td style={{ padding: '8px', maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.content}</td>
                      <td style={{ padding: '8px' }}>{item.contenttype}</td>
                      <td style={{ padding: '8px' }}>{item.pageid}</td>
                      <td style={{ padding: '8px' }}>{item.pagelocationid}</td>
                      <td style={{ padding: '8px' }}>{item.isactive}</td>
                      {/* <td>{item.createdby}</td>
                    <td>{item.createdon}</td>
                    <td>{item.updatedby}</td>
                    <td>{item.updatedon}</td> */}
                      <td style={{ padding: '8px' }}>
                        <div className="action-btn-container">
                          <Link to={`/pagecontentupdate/${item.srno}`} className="btn-action-edit">Edit</Link>
                          <button
                            className="btn-action-delete"
                            onClick={() => handleOpenDeleteModal(item)}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <DeletePageContentModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={() => handleDeletePage(pageContentToDelete.srno)}
        pageContentToDelete={pageContentToDelete}
      />
    </div>
  );
}

export default PageContentShowAll;
